// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"3d492b92","209":"f6530e2a","272":"07e18ba5","313":"53541d55","453":"9cd20449","528":"8a37d8cd","547":"08cfc334","575":"ac8d5126","784":"22be8e50"}[chunkId] + ".chunk.js";
};